import React from 'react';
import WechatProcess from 'app/components/OrderPayment/Wechat/WechatProcess';

const WechatPayment = () => {
  return <WechatProcess />;
};

export default WechatPayment;
